import { PanelistReadModel } from "@Evaluation/Estimations/Domain/readmodels";

export class SurveyAccessLinksViewModel
{
    opened: boolean = false;

    intialized: boolean = false;
    surveyId: number | null = null;
    panelists: PanelistReadModel[] = [];
    step: string = "links";

    show(surveyId: number)
    {
        this.intialized = false;
        this.surveyId = surveyId;
        this.panelists = [];
        this.step = "links";

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.intialized = false;
        this.surveyId = null;
        this.panelists = [];
        this.step = "links";
    }


    setData(panelists: PanelistReadModel[])
    {
        this.panelists = panelists;
        this.intialized = true;
    }
}